import { render, staticRenderFns } from "./parall.vue?vue&type=template&id=b94923cc&scoped=true"
import script from "./parall.vue?vue&type=script&lang=js"
export * from "./parall.vue?vue&type=script&lang=js"
import style0 from "./parall.vue?vue&type=style&index=0&id=b94923cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94923cc",
  null
  
)

export default component.exports